module.exports = __webpack_public_path__ + "static/media/citation_one.d20f5117.reality";